export default __webpack_public_path__ + "4f35fbcc9ee8614c2bcc8c28314db234.woff";